import { Box, styled } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  borderColor: theme.palette.divider,
  '& .MuiDataGrid-cell': {
    borderTopColor: theme.palette.divider,
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 'bold',
  },
}));

type Props = {
  rows: any[];
  columns: GridColDef[];
  height?: string;
  loading?: boolean;
  pageSize?: number;
};
const DataGridTable = ({ rows, columns, height = '100%', loading, pageSize = 5 }: Props) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: { height },
        maxHeight: height,
        display: 'flex',
        flexDirection: 'column',
        // alignSelf: 'stretch',
      }}
    >
      <DataGrid
        rows={rows}
        columns={columns}
        loading={loading}
        initialState={{
          pagination: { paginationModel: { pageSize } },
        }}
        pageSizeOptions={[5, 10, 25]}
        // autoPageSize
        // rowSpacingType="border"
        disableColumnMenu
        disableColumnFilter
        // disableColumnResize
        disableColumnSelector
        disableDensitySelector
        disableMultipleRowSelection
        disableRowSelectionOnClick
        density="compact"
        // hideFooter
        // hideFooterPagination
        // hideFooterSelectedRowCount
      />
    </Box>
  );
};

export default DataGridTable;
